/* NACARA — scripts propios (vanilla, sin librerías) */
(function () {
  if (window.__ncCargado) return;
  window.__ncCargado = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.nc-reveal:not(.nc-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('nc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-nc-parallax]');
    if (!imgs.length || reduce || window.__ncParallax) return;
    window.__ncParallax = true;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var k = parseFloat(img.getAttribute('data-nc-parallax')) || 0;
        var r = img.getBoundingClientRect();
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * k * -0.01;
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) rotate(' + (off * 0.04).toFixed(2) + 'deg)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initEscena() {
    var items = document.querySelectorAll('.nc-escena__item');
    if (!items.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          items.forEach(function (i) { i.classList.remove('nc-activo-item'); });
          e.target.classList.add('nc-activo-item');
        }
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || 'S/ {{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function initProducto() {
    var root = document.querySelector('[data-nc-producto]');
    if (!root || root.dataset.ncListo) return;
    root.dataset.ncListo = '1';
    var dataEl = root.querySelector('[data-nc-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var fmt = root.getAttribute('data-money-format');
    var idInput = root.querySelector('input[name="id"]');
    var precio = root.querySelector('[data-nc-precio]');
    var antes = root.querySelector('[data-nc-antes]');
    var botones = root.querySelectorAll('[data-nc-comprar]');
    var stickyPrecio = document.querySelector('[data-nc-sticky-precio]');
    var principal = root.querySelector('[data-nc-principal]');

    // Galería
    root.querySelectorAll('.nc-prod__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('.nc-prod__thumb').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        var vurl = t.getAttribute('data-video');
        var vid = root.querySelector('[data-nc-principal-video]');
        if (vurl && principal) {
          if (!vid) {
            vid = document.createElement('video');
            vid.setAttribute('data-nc-principal-video', '');
            vid.className = 'nc-prod__video';
            vid.controls = true; vid.playsInline = true; vid.muted = true; vid.loop = true;
            principal.parentNode.insertBefore(vid, principal.nextSibling);
          }
          vid.src = vurl; vid.poster = t.getAttribute('data-src');
          principal.hidden = true; vid.hidden = false;
          var pp = vid.play(); if (pp && pp.catch) pp.catch(function () {});
          return;
        }
        if (vid) { vid.pause(); vid.hidden = true; principal.hidden = false; }
        if (principal) {
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = t.getAttribute('data-src');
            principal.srcset = '';
            principal.alt = t.getAttribute('data-alt') || '';
            principal.style.opacity = 1;
          }, 180);
        }
      });
    });

    // Variantes (tarjetas de oferta). Cada radio guarda el id de su variante.
    function aplicar(v) {
      if (!v) return;
      idInput.value = v.id;
      if (precio) precio.textContent = money(v.price, fmt);
      if (stickyPrecio) stickyPrecio.textContent = money(v.price, fmt);
      if (antes) {
        if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = money(v.compare_at_price, fmt); antes.hidden = false; }
        else antes.hidden = true;
      }
      botones.forEach(function (b) {
        b.disabled = !v.available;
        var lbl = b.querySelector('[data-label]');
        if (lbl) lbl.textContent = v.available ? b.getAttribute('data-txt') : b.getAttribute('data-txt-agotado');
      });
      if (v.featured_media && principal && v.featured_media.preview_image) {
        principal.src = v.featured_media.preview_image.src + (v.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        principal.srcset = '';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    // Botón de WhatsApp: lleva el pack, el precio y el color elegidos
    var wsp = root.querySelector('[data-nc-wsp]');
    function actualizarWsp() {
      if (!wsp) return;
      var id = parseInt(idInput.value, 10);
      var v = variants.find(function (x) { return x.id === id; });
      var txt = wsp.getAttribute('data-nc-wsp-base') || '';
      if (v) txt += ' - ' + v.title + ' (' + money(v.price, fmt) + ')';
      var color = root.querySelector('input[name="properties[Color preferido]"]:checked');
      if (color) txt += ' - Color: ' + color.value;
      txt += '. Envio gratis Lima/Callao, pago al recibir.';
      wsp.href = 'https://wa.me/' + wsp.getAttribute('data-nc-wsp') + '?text=' + encodeURIComponent(txt);
    }
    root.querySelectorAll('input[data-nc-variante], input[name="properties[Color preferido]"]').forEach(function (i) {
      i.addEventListener('change', actualizarWsp);
    });
    actualizarWsp();
    root.querySelectorAll('input[data-nc-variante]').forEach(function (r) {
      r.addEventListener('change', function () {
        var id = parseInt(r.value, 10);
        aplicar(variants.find(function (v) { return v.id === id; }));
      });
    });
    // Selectores clásicos (si el producto tuviera varias opciones)
    var selects = root.querySelectorAll('select[data-nc-opcion]');
    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var vals = Array.prototype.map.call(selects, function (x) { return x.value; });
        aplicar(variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); }));
      });
    });

    // Propiedades del pedido (p. ej. color preferido)
    function propiedades(f) {
      var p = {};
      f.querySelectorAll('[name^="properties["]').forEach(function (i) {
        if ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) return;
        if (i.value) p[i.name.slice(11, -1)] = i.value;
      });
      return p;
    }
    // "Pedir ahora": añade y va directo al pago
    var form = root.querySelector('form[data-nc-form]');
    var err = root.querySelector('[data-nc-error]');
    if (form) {
      form.addEventListener('submit', function (ev) {
        var directo = ev.submitter && ev.submitter.hasAttribute('data-directo');
        ev.preventDefault();
        var btn = ev.submitter || form.querySelector('[type=submit]');
        btn.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1, properties: propiedades(form) }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Error');
            window.location.href = directo ? '/checkout' : '/cart';
          })
          .catch(function (e) {
            btn.disabled = false;
            if (err) err.textContent = e.message;
          });
      });
    }

    // Barra fija móvil
    var sticky = document.querySelector('.nc-sticky');
    var ancla = root.querySelector('[data-nc-acciones]');
    if (sticky && ancla) {
      document.body.classList.add('nc-has-sticky');
      var revisar = function () { var r = ancla.getBoundingClientRect(); sticky.classList.toggle('is-on', r.bottom < 0); };
      var pend = false;
      addEventListener('scroll', function () { if (!pend) { pend = true; setTimeout(function () { pend = false; revisar(); }, 80); } }, { passive: true });
      revisar();
      sticky.querySelector('[data-nc-sticky-btn]').addEventListener('click', function () {
        var destino = root.querySelector('[data-nc-form]') || ancla;
        var top = destino.getBoundingClientRect().top + window.pageYOffset - 84;
        window.scrollTo({ top: top, behavior: 'smooth' });
        var primero = destino.querySelector('[data-nc-variante]:not([disabled])');
        if (primero) setTimeout(function () { primero.focus({ preventScroll: true }); }, 500);
      });
    }
  }

  // Botones de compra rápida (oferta en portada)
  function initCompraRapida() {
    document.querySelectorAll('form[data-nc-rapida]:not([data-nc-listo])').forEach(function (f) {
      f.setAttribute('data-nc-listo', '1');
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = f.querySelector('[type=submit]');
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(f.querySelector('[name=id]').value, 10), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error();
          window.location.href = f.getAttribute('data-destino') || '/checkout';
        }).catch(function () { btn.disabled = false; f.submit(); });
      });
    });
  }


  /* ---- Efectos premium ---- */
  function initSplit() {
    if (reduce) return;
    document.querySelectorAll('.nc-h1:not([data-nc-split]), .nc-h2:not([data-nc-split])').forEach(function (h) {
      if (h.closest('.nc-cifras')) return;
      h.setAttribute('data-nc-split', '');
      var w = 0;
      function partir(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (pal) {
              if (!pal) return;
              if (/^\s+$/.test(pal)) { frag.appendChild(document.createTextNode(' ')); return; }
              var o = document.createElement('span'); o.className = 'nc-palabra';
              var i = document.createElement('span'); i.textContent = pal; i.style.setProperty('--w', w++);
              o.appendChild(i); frag.appendChild(o);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') { partir(n); }
        });
      }
      partir(h);
      h.classList.add('nc-split');
      if (!h.classList.contains('nc-reveal')) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { h.classList.add('nc-split-on'); io.disconnect(); } }); }, { threshold: .2 });
          io.observe(h);
        } else h.classList.add('nc-split-on');
      }
    });
  }

  function initProgreso() {
    if (reduce || document.querySelector('.nc-progreso')) return;
    var b = document.createElement('div'); b.className = 'nc-progreso'; b.setAttribute('aria-hidden', 'true');
    document.body.appendChild(b);
    var tk = false;
    function upd() { var h = document.documentElement; var m = h.scrollHeight - innerHeight; b.style.transform = 'scaleX(' + (m > 0 ? Math.min(1, scrollY / m) : 0) + ')'; tk = false; }
    addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  function initHeroRaton() {
    var v = document.querySelector('.nc-hero__visual');
    if (!v || reduce || v.__nc || !matchMedia('(hover: hover)').matches) return;
    v.__nc = true;
    var zona = v.closest('.nc-hero') || v;
    zona.addEventListener('mousemove', function (e) {
      var r = zona.getBoundingClientRect();
      v.style.setProperty('--mx', ((e.clientX - r.left) / r.width - .5) * 24 + 'px');
      v.style.setProperty('--my', ((e.clientY - r.top) / r.height - .5) * 24 + 'px');
    });
    zona.addEventListener('mouseleave', function () { v.style.setProperty('--mx', '0px'); v.style.setProperty('--my', '0px'); });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-nc-contar]:not([data-nc-ok])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-nc-ok', '');
      var fin = parseFloat(el.getAttribute('data-nc-contar')) || 0;
      if (reduce) { el.textContent = fin; return; }
      var t0 = null, dur = 1600;
      function paso(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); var e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(fin * e); if (p < 1) requestAnimationFrame(paso); }
      el.textContent = '0'; requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); } }); }, { threshold: .5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initComparador() {
    document.querySelectorAll('[data-nc-comparador]:not([data-nc-ok])').forEach(function (c) {
      c.setAttribute('data-nc-ok', '');
      var r = c.querySelector('[data-nc-comp-rango]');
      if (!r) return;
      var mq = matchMedia('(max-width: 760px)');
      var tabs = c.parentNode.querySelectorAll('[data-nc-tab]');
      function fijar(v) { c.style.setProperty('--pos', v + '%'); r.value = v; }
      function tab(v) { fijar(v); tabs.forEach(function (b) { var on = b.getAttribute('data-nc-tab') == String(v); b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); }); }
      var modoTabs = function () { return tabs.length && mq.matches; };
      tabs.forEach(function (b) { b.addEventListener('click', function () { c.__tocado = true; tab(+b.getAttribute('data-nc-tab')); }); });
      r.addEventListener('input', function () { c.__tocado = true; fijar(r.value); });
      r.addEventListener('pointerdown', function () { c.__tocado = true; c.classList.add('is-arrastrando'); });
      addEventListener('pointerup', function () { c.classList.remove('is-arrastrando'); });
      if (modoTabs()) tab(100); else fijar(50);
      var cambio = function () { if (modoTabs()) tab(0); else fijar(50); };
      if (mq.addEventListener) mq.addEventListener('change', cambio); else if (mq.addListener) mq.addListener(cambio);
      if (!('IntersectionObserver' in window)) { if (modoTabs()) tab(0); return; }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        if (modoTabs()) { setTimeout(function () { if (!c.__tocado) tab(0); }, reduce ? 0 : 1400); return; }
        if (reduce) return;
        // Pequeña demostración para que se note que se puede deslizar
        var t0 = null;
        function paso(t) {
          if (c.__tocado || modoTabs()) return;
          if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 1800);
          fijar((50 + Math.sin(p * Math.PI * 2) * 18).toFixed(1)); if (p < 1) requestAnimationFrame(paso); else fijar(50);
        }
        setTimeout(function () { requestAnimationFrame(paso); }, 500);
      }, { threshold: .45 });
      io.observe(c);
    });
  }

  /* Respaldo: si un navegador no avisa al bajar, revelamos igual por posición */
  function initRespaldo() {
    if (window.__ncRespaldo) return; window.__ncRespaldo = true;
    var pend = false;
    function revisar() {
      pend = false;
      var lim = innerHeight * 0.92;
      document.querySelectorAll('.nc-reveal:not(.nc-visible)').forEach(function (el) { if (el.getBoundingClientRect().top < lim) el.classList.add('nc-visible'); });
      document.querySelectorAll('[data-nc-split]:not(.nc-split-on):not(.nc-reveal)').forEach(function (el) { if (el.getBoundingClientRect().top < lim) el.classList.add('nc-split-on'); });
    }
    addEventListener('scroll', function () { if (!pend) { pend = true; setTimeout(revisar, 120); } }, { passive: true });
    setTimeout(revisar, 1500);
  }

  function init() { initSplit(); initReveal(); initParallax(); initEscena(); initProducto(); initCompraRapida(); initProgreso(); initHeroRaton(); initContadores(); initComparador(); initRespaldo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
